module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av571-fb1384d5c72933226b074d91fbb51654.jpg";